import { LoadingBall } from "@ingka/loading-webc/passive.js";
const generateLoadingBall = (prefixService) => {
  const loadingBallTagName = `${prefixService.prefix}-${LoadingBall.skapaTagName}`;
  const loading = document.createElement(loadingBallTagName);
  loading.id = "loader";
  loading.size = "medium";
  loading.colour = "secondary";
  return loading;
};
export {
  generateLoadingBall
};
